if (!customElements.get("multicolumn-slider")) {
  customElements.define(
    "multicolumn-slider",
    class MulticolumnSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: ".multicolumn__items",
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          pagination: ".swiper-pagination",
        };
        this.classes = {
          grid: "f-grid",
          swiper: "swiper",
          swiperWrapper: "swiper-wrapper",
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`[data-id="${this.sectionId}"]`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === "true";
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.paginationType = this.dataset.paginationType || "progressbar";

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === "object") return;
        const columnGap = window
          .getComputedStyle(this.sliderWrapper)
          .getPropertyValue("--f-column-gap");
        const spaceBetween = parseFloat(columnGap.replace("rem", "")) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          this.sliderOptions,
          [FoxTheme.Swiper.Mousewheel],
        );
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== "object") return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== "center_image") return;

        const firstMedia = this.querySelector(".multicolumn-card__image");
        const controls = this.section.querySelector(".swiper-controls");
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty(
            "--swiper-navigation-top-offset",
            parseInt(firstMedia.clientHeight) / 2 + "px",
          );
        }
      }
    },
  );
}
